module.exports = __webpack_public_path__ + "static/media/productTypecreditCard.e3620e43.svg";